import { Component, Input, OnInit } from "@angular/core";
import { TableModule } from "primeng/table";
import { DistributionController } from "@app/ui_controllers/distributionController";
import { DistributionPageDto, DistributionPreviewPageDto, MNN } from "@app/ui_models/web-response";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-view-distribution-modal",
  standalone: true,
  imports: [
    TableModule,
    CommonModule,
  ],
  templateUrl: "./view-distribution-modal.component.html",
  styleUrl: "./view-distribution-modal.component.scss",
})
export class ViewDistributionModalComponent implements OnInit {
  @Input() distributionId!: number;
  @Input() isDoz!: boolean;

  distribution: DistributionPreviewPageDto | null = null;

  constructor(private readonly distributionController: DistributionController) {
  }

  ngOnInit(): void {
    if (this.isDoz) {
      this.distributionController.getDistributionPreviewDoz(this.distributionId).subscribe(data => {
        this.distribution = data as DistributionPreviewPageDto;
      });
    } else {
      this.distributionController.getDistributionPreview(this.distributionId).subscribe(data => {
        this.distribution = data as DistributionPreviewPageDto;
      });
    }
  }

  formatHeaderText(mnn: MNN): string {
    const HEADER_TEXT3 = "%s %s <br>Ціна за флакон - %s %s<br>(mnn id: - %s)";
    return HEADER_TEXT3
      .replace("%s", mnn.name)
      .replace("%s", mnn.dose)
      .replace("%s", mnn.formattedPrice)
      .replace("%s", "грн")
      .replace("%s", String(mnn.id));
  }
}
